import styled_components from "styled-components";
import { Absolute, Box } from "pcln-design-system";
const ChatHistoryControlWrapper = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "ChatContent.styles__ChatHistoryControlWrapper"
})([
    "text-align:center;display:inline-flex;justify-content:center;margin-bottom:20px;margin-top:14px;"
]);
const ChatHistoryControl = /*#__PURE__*/ styled_components(Box).withConfig({
    displayName: "ChatContent.styles__ChatHistoryControl"
})([
    "cursor:pointer;"
]);
const ToastWrapper = /*#__PURE__*/ styled_components(Absolute).withConfig({
    displayName: "ChatContent.styles__ToastWrapper"
})([
    "width:300px;left:50%;transform:translate(-50%,-50%);top:40px;"
]);
export { ChatHistoryControl, ChatHistoryControlWrapper, ToastWrapper };
